export default defineNuxtPlugin((nuxtApp) => {
	const { getToken } = useAuth();

	nuxtApp.hook("apollo:auth", ({ token }) => {
		token.value = getToken();
	});
});
